import type { IButtonProps } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<Partial<IButtonProps>>;

const NewAssetButton = ({ children, onClick }: Props) => {
    return (
        <Button
            type="primary"
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

export default NewAssetButton;
